import { SvgIcon } from '@mui/material';

import type * as React from 'react';
import type { BaseIconProps } from '../types';

export const LongArrowNextIcon: React.FC<BaseIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 20 10" fillRule="evenodd" stroke="none" {...props}>
      <path
        d="M19 6H1C0.734784 6 0.48043 5.89464 0.292893 5.70711C0.105357 5.51957 0 5.26522 0 5C0 4.73478 0.105357 4.48043 0.292893 4.29289C0.48043 4.10536 0.734784 4 1 4H19C19.2652 4 19.5196 4.10536 19.7071 4.29289C19.8946 4.48043 20 4.73478 20 5C20 5.26522 19.8946 5.51957 19.7071 5.70711C19.5196 5.89464 19.2652 6 19 6Z"
        fill="currentColor"
      />
      <path
        d="M15 9.99628C14.8684 9.99704 14.7379 9.97182 14.6161 9.92205C14.4943 9.87229 14.3834 9.79896 14.29 9.70628C14.1963 9.61331 14.1219 9.50272 14.0711 9.38086C14.0203 9.259 13.9942 9.12829 13.9942 8.99628C13.9942 8.86427 14.0203 8.73356 14.0711 8.6117C14.1219 8.48984 14.1963 8.37924 14.29 8.28628L17.59 4.99628L14.29 1.70628C14.1017 1.51798 13.9959 1.26258 13.9959 0.996279C13.9959 0.729978 14.1017 0.474583 14.29 0.286279C14.4783 0.0979755 14.7337 -0.0078125 15 -0.0078125C15.2663 -0.0078125 15.5217 0.0979755 15.71 0.286279L19.71 4.28628C19.8037 4.37924 19.8781 4.48984 19.9289 4.6117C19.9797 4.73356 20.0058 4.86427 20.0058 4.99628C20.0058 5.12829 19.9797 5.259 19.9289 5.38086C19.8781 5.50272 19.8037 5.61332 19.71 5.70628L15.71 9.70628C15.6166 9.79896 15.5057 9.87229 15.3839 9.92205C15.2621 9.97182 15.1316 9.99704 15 9.99628Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
